import { useCallback, useEffect } from 'react';
import { downloadBlob } from '#shared/lib/file';
import { showError } from '#shared/lib/toast';
import { useLazyExportCharacteristicsGroups } from '../api';

export const useCharacteristicGroupsDownload = () => {
    const [fetchGroups, { isFetching: isLoading, status, data, isSuccess, isError }] =
        useLazyExportCharacteristicsGroups({});
    const downloadGroups = useCallback(() => {
        fetchGroups(undefined);
    }, [fetchGroups]);

    useEffect(() => {
        if (!data) {
            return;
        }

        const { blobData, filename } = data;

        if (isSuccess) {
            const hasBlobDocument = blobData && blobData instanceof Blob;

            hasBlobDocument
                ? downloadBlob(blobData, filename)
                : showError({ label: 'Произошла ошибка при загрузке файла' });
        } else if (isError) {
            showError({ label: 'Произошла ошибка при загрузке файла' });
        }
    }, [data, isError, isSuccess, status]);

    return { isLoading, downloadGroups };
};
